import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Import } from '@mint-lib/icons';
import { useMutationState } from '@mint-lib/query-client';
import { useFlags } from '@mint-lib/routing-context';
import {
  Button,
  Dialog,
  DialogOverlay,
  DialogTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@mint-lib/tw-components';

import { IMPORT_VALIDATION_MUTATION_KEY } from '../../../../../../api/mutations/useImportActivity.js';
import { useActivityByMediaDataId } from '../../../../../../hooks/useActivityByMediaDataId.js';
import { useChosenLevel } from '../../../../../../hooks/useChosenLevel.js';
import { DialogContentImport } from './DialogContentImport.jsx';

export const ImportPlanModal = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const ff = useFlags('@mint/arm', ['disableActivityLevel']);

  const { id } = useChosenLevel();
  const activity = useActivityByMediaDataId(id);
  const isImportDisabled = activity?.subItems.length === 0;

  const [open, setOpen] = useState<boolean>(false);

  const status = useMutationState({
    filters: { mutationKey: IMPORT_VALIDATION_MUTATION_KEY },
    select: (state) => state.state.status,
  }).at(-1);

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && status === 'pending') {
      return;
    }

    setOpen(isOpen);
  };

  return (
    <Dialog modal open={open} onOpenChange={handleOpenChange}>
      {ff.disableActivityLevel.enabled ? (
        <DialogTrigger asChild>
          <Button variant="text">
            <Import />
            {t('Import activity')}
          </Button>
        </DialogTrigger>
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <DialogTrigger asChild>
                <Button variant="text" disabled={isImportDisabled}>
                  <Import />
                  {t('Import activity')}
                </Button>
              </DialogTrigger>
            </span>
          </TooltipTrigger>

          {isImportDisabled && (
            <TooltipContent className="z-tooltip">
              {t('You need to have flights inside the activity')}
            </TooltipContent>
          )}
        </Tooltip>
      )}

      <DialogOverlay />
      {open && <DialogContentImport handleOpenChange={handleOpenChange} />}
    </Dialog>
  );
};
